import React, { useState } from "react";
import { changePassword } from "../../../../services/userMangement/userManagement";
import { FaTimes } from "react-icons/fa";
import PasswordInput from "./../../../../components/password";
import { InputField } from "../../../../components/Stepper/fields/inputField";
import { useNavigate } from "react-router-dom";
import { handleErrorRedirect } from "../../../../utility/errorRedirect";

const ChangeUserPassewordModal = ({
  visible,
  fetchUsers,
  onHide,
  toast,
  selectedUser,
  setLoading,
  loading,
}) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const navigate = useNavigate();

  const validateFields = () => {
    let isValid = true;
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

    // Validate password
    if (!password) {
      setPasswordError("Password is required");
      isValid = false;
    } else if (!passwordRegex.test(password)) {
      setPasswordError(
        "Password must be at least 8 characters long, include 1 uppercase letter, 1 number, and 1 special character"
      );
      isValid = false;
    }

    // Validate confirm password
    if (!confirmPassword) {
      setConfirmPasswordError("Confirm Password is required");
      isValid = false;
    } else if (password !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match");
      isValid = false;
    }

    return isValid;
  };

  const handleSave = async () => {
    if (!validateFields()) return;
    clearErrors();
    setLoading(true);

    try {
      const accessToken = JSON.parse(localStorage.getItem("access_token"));
      const payload = { new_password: password };

      const response = await changePassword(
        payload,
        accessToken,
        selectedUser.id
      );
      if (response) {
        await fetchUsers();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: response.data.message,
          life: 3000,
        });
        resetFields();
        onHide();
      }
    } catch (error) {
      const status = error?.response?.status;
      handleErrorRedirect(status, navigate);
      console.error("Error saving user:", error);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: error.message,
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = (value) => {
    setPassword(value);
    if (passwordError) setPasswordError("");
  };

  const handleChangeConfirmPassword = (value) => {
    setConfirmPassword(value);
    if (confirmPasswordError) setConfirmPasswordError("");
  };

  const clearErrors = () => {
    setPasswordError("");
    setConfirmPasswordError("");
  };

  const resetFields = () => {
    setPassword("");
    setConfirmPassword("");
  };

  const handleCancel = () => {
    resetFields();
    clearErrors();
    onHide();
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50 overflow-y-auto">
      <div className="dark:bg-custom-radial bg-[#F6F6F6] md:w-1/3 w-full max-h-[90vh] overflow-y-auto shadow-lg p-6 text-[rgba(255,255,255,1)] rounded-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-semibold text-lightPrimary text-black dark:text-primary-gradient">
            Change Password
          </h2>
          <FaTimes
            onClick={handleCancel}
            className="cursor-pointer text-lg text-lightPrimary dark:text-darkWaring"
          />
        </div>

        <div className="field mb-4">
          <InputField
            label="Email Address*"
            placeholder="Enter your Email Address"
            name="email"
            value={selectedUser?.email || ""}
            required={true}
            disabled={true}
          />
        </div>
        <div className="space-y-4">
          <PasswordInput
            label="Password*"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => handleChangePassword(e.target.value)}
            required={true}
            errors={passwordError}
          />

          <PasswordInput
            label="Confirm Password*"
            placeholder="Enter your Confirm password"
            value={confirmPassword}
            onChange={(e) => handleChangeConfirmPassword(e.target.value)}
            required={true}
            errors={confirmPasswordError}
          />
        </div>

        <div className="mt-6 flex gap-4">
          <button
            onClick={handleSave}
            className={`bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 flex items-center justify-center ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save"}
          </button>
          <button
            onClick={handleCancel}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangeUserPassewordModal;
